import { render, staticRenderFns } from "./CallToActionButton.vue?vue&type=template&id=50e25b56&"
import script from "./CallToActionButton.vue?vue&type=script&lang=js&"
export * from "./CallToActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports